import { CTSAReportState } from '../interface/CTSAReportInterface';


export default function (state: CTSAReportState = {}, action) {
    let propertyName: string;

    switch (action.type) {
        case "GET_CAREER_DATA":
            propertyName = "careerData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_AWARD_DATA":
            propertyName = "awardData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_AWARD_TOTAL":
            propertyName = "awardTotal";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_AWARD_PATHWAY":
            propertyName = "awardPathway";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_KL2_MODALPATH":
            propertyName = "kl2ModalPathway";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_PATENT_NUMBER":
            propertyName = "patentNumber";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_PATENT_SECTOR":
            propertyName = "patentSector";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_BIBS":
            propertyName = "bibs";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_JOURNALS":
            propertyName = "journals";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_MESHTERMS":
            propertyName = "mesh";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_TEAM":
            propertyName = "team";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_TEAM_GENDER":
            propertyName = "teamGender";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "CHANGE_COMPARISON_GROUP":
            propertyName = "comparisonGroup";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_AVAILABLE_GROUP":
            propertyName = "availableGroup";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_METHODOLOGY_MATCH":
            propertyName = "methodologyMatch";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_METHODOLOGY_GROUP":
            propertyName = "methodologyGroup";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "DOWNLOAD":
            return state;
        default:
            return state;
    }
}